import { prefixKey } from "helpers/storage-helper/storage-helper";

type LocalStorageKey =
	| "userId"
	| "appId"
	| "appName"
	| "appFeatures"
	| "links"
	| "accessToken"
	| "firebaseConfig"
	| "placeTimezoneName"
	| "preferredPaymentMethod" // deprecated
	| "preferredPayment"
	| "i18nextLng"
	| "testThemeName"
	| "resolvedAppLink"
	| "signInLinkEmail"
	| "hasSeenSignIn"
	| "[testalias]accessToken"; // Used by e2e

export function getLocalStorage<T>(key: LocalStorageKey): T | null {
	const localStorageKey = prefixKey(key);

	try {
		const data: string | null = window.localStorage.getItem(localStorageKey);
		if (data === null) return null;
		return JSON.parse(data).value as T;
	} catch {
		// Invalid JSON or storage blocked (private mode, restricted webview)
		deleteLocalStorage(key);
		return null;
	}
}

export function setLocalStorage(key: LocalStorageKey, value: unknown): void {
	const data = JSON.stringify({ value });
	try {
		window.localStorage.setItem(prefixKey(key), data);
	} catch {
		// Storage blocked or full, value is not persisted
	}
}

/** Pass `prefixed: false` for keys a library owns and writes without the app-alias prefix. */
export function deleteLocalStorage(key: LocalStorageKey, { prefixed = true } = {}): void {
	try {
		window.localStorage.removeItem(prefixed ? prefixKey(key) : key);
	} catch {
		// Storage blocked, nothing to remove
	}
}

export function clearLocalStorage(): void {
	try {
		window.localStorage.clear();
	} catch {
		// Storage blocked, nothing to clear
	}
}
